module.exports = __webpack_public_path__ + "components/promo-app/static/app-mobile-bg-c70b7a95f92c5c4ceec4d67bb5eb800d.jpg";